<template>
  <div>
    <logged-in-header />
    <invoices-pack-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import invoicesPackPanel from "../components/invoices-pack/InvoicesPackPanel";

export default {
  components: {
    loggedInHeader,
    invoicesPackPanel
  }
};
</script>
